// extracted by mini-css-extract-plugin
export default {"disableClick":"Vtex_2","grid-stack":"jQLPBT","gridStack":"jQLPBT","typeCircle":"Q57Sd1","typeSquare":"plI5OO","typeNone":"TV5Wwe"};